import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

import { Constants } from 'app/shared/shared-constants';
import { format } from 'shell-models-lib';

export const sharePointOnlineListResourceMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.sharePointOnlineList.datasetType,
    displayName: stringResources.SharePointOnlineList_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.sharePointOnlineList.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-sharepoint'
    },
    tableNameDisplay: stringResources.List_Name,
    tableNamePlural: stringResources.Lists,
    isFirstClass: true,
    isTableNameRequired: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    category: ['ServicesApps'],
    tableAlias: 'listName',
    queryDescription: stringResources.SharePointOnlineListResource_Query_Description,
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'httpRequestTimeout',
                label: stringResources.ModelName_Request_Timeout,
                description: stringResources.SharePointOnlineListSource_HttpRequest_Description,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_Request_Timeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ]
};
